<template>
  <div>
    <Modal v-if="order" max-width="340" :show.sync="showOrderStatusModal" :close="closeOrderStatusModal">
      <template #title>
        <span class="title">Bloquer/Débloquer les contrats de commande</span>
      </template>
      <template #text>
        <h2 class="bold">
          Voulez-vous {{ modalText }} le contrat pour le commande {{ order.uuid }}?
        </h2>
      </template>
      <v-spacer />
      <template #actions>
        <v-col>
          <v-btn width="292" class="mr- mb-2" color="primary" @click="changeOrderStatus()">
            <span class="ml-2 d-none d-sm-inline-block">Oui</span>
          </v-btn>
          <v-btn width="292" class="mr-2" color="secondary" @click="closeOrderStatusModal()">
            <span class="ml-2 d-none d-sm-inline-block">Non</span>
          </v-btn>
        </v-col>
      </template>
    </Modal>
  </div>
</template>
<script>
import { EventBus } from '../../mixins';
import Modal from '@/components/Modal/Modal';

import { requests } from '@/mixins/index';

export default {
  components: { Modal },
  mixins: [requests],
  props: {
    order: {
      type: Object,
      default: null
    }
  },
  data () {
    return { showOrderStatusModal: false };
  },
  computed: {
    modalText () {
      return this.$props.order && this.$props.order.isBlocked ? 'débloquer' : 'bloc';
    }
  },
  mounted () {
    EventBus.$on('show-alpha-order-status-modal', () => {
      this.showOrderStatusModal = true;
    });
  },
  methods: {
    closeOrderStatusModal () {
      this.showOrderStatusModal = false;
      EventBus.$emit('handle-order-alpha-status', { advance: false });
    },
    async changeOrderStatus () {
      this.showOrderStatusModal = false;

      const notification = {
        message: `${this.modalText} le contract`,
        type: 'info',
        timeout: 16000
      };
      EventBus.$emit('show-notifications', [notification]);

      EventBus.$emit('handle-order-alpha-status', { advance: true });
    }
  }
};
</script>
